<template>
  <div
    class="help-component"
    :class="prefixCls"
    @click="
      $router.push({name:'helpCenter'})
    "
  >
    <a-icon type="question-circle" style="font-size: 20px; cursor: pointer;  display: inline-block" />
  </div>
</template>

<script>
export default {
  props: {
    prefixCls: {
      type: String,
      default: 'ant-pro-global-header-index-action',
    },
    showMessagePop: {
      type: Boolean,
      default: false,
    },
    msgContent: {
      type: String,
      default: '',
    },
    msgId: {
      type: String,
      default: '',
    },
    count: {
      type: Number,
      default: 0,
    },
  },
  created() {
    this.getMessageCenterData()
  },
  computed: {
    allCount() {
      return this.$store.state.messageCenter.allCount
    },
    messageCenterData() {
      return this.$store.state.messageCenter.messageCenterData
    },
  },
  methods: {
    goMessageCenterPage(item) {
      this.$store.commit('CHANGE_MESSAGETYPE', item.messageType)
      this.$router.push({
        path: '/messageCenter',
        // query: { id: this.msgId },
      })
    },
    getMessageCenterData() {
      this.$store.dispatch('getMessageCenterData')
    },
    
  },
}
</script>

<style lang="less" scoped></style>
<style lang="less">
.message-content {
  position: relative;
}
.message-pop {
  right: 0;
  top: 80%;
  height: 40px;
  min-width: 300px;
  position: absolute;
  border: 1px solid #e8e8e8;
  background-color: white;
  text-align: center;
  line-height: 40px;
  border-radius: 10px;
}
</style>
